import { render, staticRenderFns } from "./IntegrationSidebar.vue?vue&type=template&id=34da6186"
import script from "./IntegrationSidebar.vue?vue&type=script&lang=js"
export * from "./IntegrationSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports